import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import i18n from './locales/index'
import './filters'
import './directives'
import { urlIsSanitizable } from './utils/security'
import Vue2Filters from 'vue2-filters'
import VueMoment from 'vue-moment'
import VueCurrencyInput from 'vue-currency-input'
import { Integrations } from '@sentry/tracing'
import * as Sentry from '@sentry/vue'
import { Replay } from '@sentry/replay'

Vue.config.productionTip = false

// Axios instance initialization and configuration
// axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

axios.interceptors.request.use((config) => {
  if (['post', 'put', 'patch'].includes(config.method)) {
    // check urls
    const sanitizeUrl = urlIsSanitizable(config.url)
    if (sanitizeUrl && config.data) {
      let dataToSanitize = JSON.stringify(config.data).split('')
      // eslint-disable-next-line
      const regexp = new RegExp(/(\b)(on\S+)(\s*)=|javascript|<(|\/|[^\/>][^>]+|\/[^>][^>]+)>/ig)
      let sanitizedData = dataToSanitize.filter(el => !regexp.test(el)).join('')
      config.data = JSON.parse(sanitizedData)
    }
  }
  return config
}, error => {
  store.dispatch('Snackbars/addError', i18n.t('snackbar_sanitizing_error'))
  Promise.reject(error)
})

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token != null) {
    config.headers.Authorization = `Bearer ${token}`
    if (store.getters['LoginStore/isImpersonating']) {
      config.headers['x-switch-user'] = store.getters['LoginStore/user'].email
    }
  }
  // Initialize header based on current language
  config.headers['x-locale'] = i18n.locale

  return config
}, error => Promise.reject(error))
// Sentry initialization
if (!window.location.href.includes('localhost')) {
  Sentry.init({
    Vue: Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    release: process.env.RELEASE_VERSION,
    // This enables automatic instrumentation (highly recommended), but is not
    // necessary for purely manual usage
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['https://dev.getfuell.com', 'https://pre.getfuell.com', 'https://app.getfuell.com', /^\//]
      }), new Replay({
        // Capture 10% of all sessions
        sessionSampleRate: 0.1,

        // Of the remaining 90% of sessions, if an error happens start capturing
        errorSampleRate: 1.0
      })],
    // To set a uniform sample rate
    tracesSampleRate: 0.2,
    beforeSend (event, hint) {
      // Check if it is an exception, and if so, show the report dialog
      // if (event.exception) {
      //   Sentry.showReportDialog({ eventId: event.event_id, user: store.getters['UsersStore/userLogged'] })
      // }
      return event
    }
  })
}

// TODO: Refactor
var isAlreadyFetchingAccessToken = false
axios.interceptors.response.use((response) => response, (error) => {
  if (!error.response) return Promise.reject(error)
  const { config, response: { status } } = error
  const originalRequest = config
  if (status === 401 && localStorage.getItem('refreshToken')) {
    if (!isAlreadyFetchingAccessToken) {
      isAlreadyFetchingAccessToken = true
      store.dispatch('LoginStore/refreshToken').then((res) => {
        isAlreadyFetchingAccessToken = false
        return originalRequest // TODO: needing await for refresh token...
      })
    }
  }
  return Promise.reject(error)
})

Vue.use(Vue2Filters)
Vue.use(VueCurrencyInput, {
  globalOptions: {
    locale: 'de',
    currency: 'EUR'
  }

})

// Testing
store.subscribe((mutation, state) => {
  if (!store.getters['LoginStore/isImpersonating']) {
    if (state['BenefitsStore'].retFlexColumns && state['BenefitsStore'].retFlexColumns.length > 0) {
      localStorage.setItem('retFlexColumns', JSON.stringify(state['BenefitsStore'].retFlexColumns))
    }
    if (state['BenefitsStore'].subventionColumns && state['BenefitsStore'].subventionColumns.length > 0) {
      localStorage.setItem('subventionColumns', JSON.stringify(state['BenefitsStore'].subventionColumns))
    }
  }
})

Vue.use(VueMoment, {})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
